import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { SelfInvoiceItemsFooterProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { StaticInfoMessage } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SelfInvoiceItemsFooter: React.FC<SelfInvoiceItemsFooterProps> = (props) => {
  const { interpretedItemsTotal, totalExTax, total, taxCalculations, itemsUpdated, currency } = props;

  return (
    <Grid container rowGap={2}>
      <Grid
        item
        container
        direction="row"
        columnGap={2}
        className={cssExports.invoiceTotalAmountFooter}
        paddingRight="48px"
      >
        <Grid item xs>
          <Grid
            item
            container
            justifyContent="end"
            className={cssExports.subTotalValue}
          >{`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Total
          )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ExVat)}:`}</Grid>
          {taxCalculations?.length ? (
            taxCalculations.map((taxCalculation) => (
              <Grid
                item
                container
                justifyContent="end"
                className={cssExports.subTotalValue}
              >{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.VAT)} ${
                taxCalculation.vatType
              }%:`}</Grid>
            ))
          ) : (
            <Grid item container justifyContent="end" className={cssExports.subTotalValue}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.VAT)}
            </Grid>
          )}
          <Grid
            item
            container
            justifyContent="end"
            className={cssExports.totalValue}
          >{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Total)}:`}</Grid>
        </Grid>
        <Grid item>
          <Grid item container justifyContent="end" className={cssExports.subTotalValue}>
            {LocalizationHelperInstance.getFormattedCurrency(totalExTax, currency, 2)}
          </Grid>
          {taxCalculations?.length ? (
            taxCalculations.map((taxCalculation) => (
              <Grid item container justifyContent="end" className={cssExports.subTotalValue}>
                {LocalizationHelperInstance.getFormattedCurrency(taxCalculation.amount, currency, 2)}
              </Grid>
            ))
          ) : (
            <Grid item container justifyContent="end" className={cssExports.subTotalValue}>
              {LocalizationHelperInstance.getFormattedCurrency(0, currency, 2)}
            </Grid>
          )}
          <Grid item container justifyContent="end" className={cssExports.totalValue}>
            {LocalizationHelperInstance.getFormattedCurrency(total, currency, 2)}
          </Grid>
        </Grid>
      </Grid>
      {itemsUpdated && interpretedItemsTotal !== totalExTax ? (
        <StaticInfoMessage>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Invoice.SelfInvoiceUpdatedTotalMismatchWarning
          )}
        </StaticInfoMessage>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default SelfInvoiceItemsFooter;
